import React from 'react';
import './FlippableCard.css';

const FlippableCard = ({ icon, title, description, points, isFlipped, onFlip }) => {
  return (
    <div className={`flippable-card-scene${isFlipped ? ' is-flipped' : ''}`}>
      <div className="flippable-card">
        <div className="flippable-card-face flippable-card-front">
          <div className="card-front-top">
            <img className="card-icon" src={icon} alt={title} />
            <span className="card-title">{title}</span>
          </div>
          <p className="card-description">{description}</p>
          <button
            className="card-flip-btn card-flip-btn--front"
            onClick={onFlip}
            aria-label="See more"
          >
            <img src="assets/icons/arrow-right.svg" alt="Right arrow" />
          </button>
        </div>

        <div className="flippable-card-face flippable-card-back">
          <ul className="card-points-list">
            {points.map((point, i) => (
              <li key={i}>{point}</li>
            ))}
          </ul>
          <button
            className="card-flip-btn card-flip-btn--back"
            onClick={onFlip}
            aria-label="Close"
          >
            <img src="assets/icons/cross.svg" alt="Close" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FlippableCard;
